import { RegistrationController } from '../../controllers/registration-controller'
import { inject } from 'aurelia-framework';
import { Redirect, Router } from 'aurelia-router';

@inject(Router, RegistrationController)
export class Details {

    constructor(private router: Router, public reg: RegistrationController) {
    }

    canActivate(params): any {
        if (!this.reg.carrier) {
            return new Redirect("registration/begin?id=" + params.id);
        }
        return Promise.resolve(true);
    }
}